import { IColumnHeader } from '@aon/aon-tws-common-ui';
import { IQueryableTableColumn, ISelectableTableColumn } from '../../../../components/reporting/GroupAccessOwners/QueryableTableView';
import { TRenderRowAs, IRenderRowAsTableRow } from '../../../../components/reporting/GroupAccessOwners/TableView';
import {
	IGroupAccessOwnerColumn,
	IsOwnerColumnQueryable,
	IsOwnerColumnSelectable,
} from '../../../../models/GroupAccessOwners/GroupAccessOwnerColumn';
import { IGroupAccessOwnerRowData } from '../../../../models/GroupAccessOwners/GroupAccessOwnerRow';

export function GenerateRowRenderTemplate(
	columns: IGroupAccessOwnerColumn[],
	renderExpandedRowContent?: (rowData: IGroupAccessOwnerRowData) => any,
): TRenderRowAs<IGroupAccessOwnerRowData> {
	const baseTemplate: IRenderRowAsTableRow<IGroupAccessOwnerRowData> = {
		type: 'TableRow',
		rowIdentifier: (row) => row.owner.PersonId,
		renderCell: columns.reduce(
			(renderInstructions, col) => ({
				...renderInstructions,
				[col.header.field]: col.render.cellData,
			}),
			{} as TRenderRowAs<IGroupAccessOwnerRowData>['renderCell'],
		),
	};

	if (renderExpandedRowContent !== undefined) {
		return {
			...baseTemplate,
			type: 'TableRowWithExpander',
			expandedRowContent: renderExpandedRowContent,
		};
	} else {
		return baseTemplate;
	}
}

export function GenerateTableColumns(columns: IGroupAccessOwnerColumn[]): IColumnHeader[] {
	const AsQueryableDataColumn = (column: IGroupAccessOwnerColumn): IQueryableTableColumn | undefined => {
		if (IsOwnerColumnQueryable(column)) {
			return {
				...column.header,

				isQueryable: true,
				fieldName: column.asQueryable.fieldName,
				boundToEntity: column.asQueryable.boundToEntity,
			};
		}
	};

	const AsSelectableDataColumn = (column: IGroupAccessOwnerColumn): ISelectableTableColumn | undefined => {
		if (IsOwnerColumnSelectable(column)) {
			return {
				...column.header,

				isSelectable: true,
				makeDefaultSelectable: column.asSelectable.selectedByDefault,
				lockSelection: column.asSelectable.selectionLocked,
			};
		}
	};

	return columns.map((col) => {
		return {
			...col.header,
			...AsQueryableDataColumn(col),
			...AsSelectableDataColumn(col),
		};
	});
}
